import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User removed from a library',
  name: 'removed_library_member',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the updated library member',
      name: 'library_member_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The role of the updated library member',
      name: 'library_member_role_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
